import Vue from 'vue';
import Router from 'vue-router';
import Trade from '@/views/Trade.vue';
import Balance from '@/views/Balance';
import Register from '@/views/Register.vue';
import Import from '@/views/ImportUser.vue';
import Orders from '@/views/Orders';
import Histroy from '@/views/History.vue';
import Index from '@/views/Index.vue';
import SetFundPassword from '@/views/SetFundPassword.vue';
import GetToken from '@/views/GetToken.vue';
// import Ttdex from '@/views/Ttdex.vue';

import Config from '../utils/Config';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  const result = originalPush.call(this, location);
  return result && result.catch ? result.catch(err => err) : result;
//   return originalPush.call(this, location).catch(err => err)
}
const IndexMap =  {
    Index,
    Balance,
    // Ttdex,
};
// import Ttdex from '@/views/Ttdex.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/Trade',
            name: 'Trade',
            component: Trade,
        },
        {
            path: '/Balance',
            name: 'Balance',
            component: Balance,
        },
        {
            path: '/Register',
            name: 'Register',
            component: Register,
        },
        {
            path: '/Import',
            name: 'Import',
            component: Import,
        },
        {
            path: '/Orders',
            name: 'Orders',
            component: Orders,
        },
        {
            path: '/History',
            name: 'History',
            component: Histroy,
        },
        {
            path: '/',
            name: Config.index,
            component: IndexMap[Config.index],
        },
        // {
        //     path: '/Reg',
        //     name: 'Reg',
        //     component: Reg,
        // },
        {
            path: '/SetFundPassword',
            name: 'SetFundPassword',
            component: SetFundPassword,
        },
        {
            path: '/GetToken',
            name: 'GetToken',
            component: GetToken,
        },
        {
            path: '/KYC',
            name: 'KYC',
            component: () => import('@/views/KYC'),
            children: [
                { path: '', redirect: 'step1' },
                { path: 'step1', component: () => import('@/views/KYC/step1') },
                { path: 'step2', component: () => import('@/views/KYC/step2') },
                { name: 'kyc-review', path: 'review', component: () => import('@/views/KYC/review'), props: true },
            ],
        },
        {
            path: '/STO',
            name: 'STO',
            component: () => import('@/views/ICO'),
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js